import styled from 'styled-components'
import { TabletBreakpoint } from '../../styles/functions';
// import ButtonInline from 'frontend/src/components/button/ButtonInline';
import { TypeBodyM, TypeCaptionM } from '../../styles/mixins'
import SanityLink from '../sanity/SanityAnnotationLink';

interface P {
  sidebar: any 
  mode: "LINKS" | "ANCHOR"
}

const SidebarLinks: React.FC<P> = ({ sidebar, mode }: P) => {
  const {title, links} = mode == "LINKS" ? sidebar.links : sidebar.scrollLinks;
  
  return (
    <Container>
      <Title>{title}</Title>
      <Links>
        { links.map((link) =>
        <Link link={link.link || link} key={link._key}>
          {link.title}
        </Link>
        )}
      </Links>
    </Container>
  )
}

const Container = styled.nav`

`

const Title = styled.h2`
  ${TypeCaptionM}
  margin-bottom: 16px;
`

const Links = styled.nav`
${TypeBodyM}
counter-reset: links;
  
  >* + * {
    // margin-top: 1em;
  }
`

const Link = styled(SanityLink)`
  counter-increment: links;
  display: grid;
  grid-template-columns: 40px 1fr;

  ${TabletBreakpoint(`
    grid-template-columns: 32px 1fr;
  `)}
  
  &:before {
    display: inline-flex;
    content: counter( links , decimal-leading-zero) '.';
  }
`

export default SidebarLinks
